import Splide from '@splidejs/splide';

const ProgrammePresentation = () => {
    const selector = 'section.program-presentation .splide';

    const init = () => {
        const splide = new Splide(selector, {
            type   : 'fade',
            perPage: 1,
            perMove: 1,
            pagination: false,
            //heightRatio: 0.70,
            //cover: true,
        }).mount();

        splide.on('active', function ( SlideComponent ) {
            // do something
            $(selector + ' .js--program-presentation-loop-title').html(
                $(SlideComponent.slide).find('h3').html()
            );
        });

        splide.on('click', function () {
            splide.go('+1');
        });
    }

    if ($(selector).length > 0) {
        init();
    }

    /* return ({
        init,
    }); */
}
export default ProgrammePresentation;
